export function getConfig() {
    return fetch(`${location.origin}/sveden/update/api_profile_applicant/get_config.php`)
        .then((response) => {
            return response.status === 200 ? response.json() : Promise.reject(response.statusText);
        })
        .catch((err) => {
            console.log(err);
        });
}
